import React from "react";
import PropTypes from "prop-types";

import HexColorInput from "./HexColorInput";
import RgbColorInput from "./RgbColorInput";

import {
    ColorSelectionContainer,
    ColorInputContainer,
    SelectedColor
} from "./styles";

const ColorSelectionControls = ({
    activeColor,
    setActiveColor,
    colorTextInputValue,
    background
}) => {
    return (
        <ColorSelectionContainer>
            <SelectedColor data-testid="selected-color" color={activeColor} />

            {/* COLOR HEX PICKER TEXT INPUT */}
            <ColorInputContainer>
                <HexColorInput
                    setActiveColor={setActiveColor}
                    activeColor={activeColor}
                    colorTextInputValue={colorTextInputValue}
                    background={background}
                />
            </ColorInputContainer>

            {/* COLOR RGB PICKER TEXT INPUT */}
            <ColorInputContainer>
                <RgbColorInput
                    setActiveColor={setActiveColor}
                    activeColor={activeColor}
                    colorTextInputValue={colorTextInputValue}
                    background={background}
                />
            </ColorInputContainer>
        </ColorSelectionContainer>
    );
};

ColorSelectionControls.propTypes = {
    activeColor: PropTypes.string.isRequired,
    setActiveColor: PropTypes.func.isRequired
};

export default ColorSelectionControls;
